__turbopack_context__.v({
  "Image": "Full-module-scss-module__83ciwa__Image",
  "blink": "Full-module-scss-module__83ciwa__blink",
  "full": "Full-module-scss-module__83ciwa__full",
});
